/**
 * @generated SignedSource<<95d006faa2432d6897ef2c458d2d6073>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Notifications_viewer$data = {
  readonly regInfo?: ReadonlyArray<{
    readonly countryCode: string | null;
  } | null> | null;
  readonly isAutomatedOfferNotificationDisabled: boolean | null;
  readonly conversations?: {
    readonly " $fragmentSpreads": FragmentRefs<"Conversations_conversations">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityFeed_viewer">;
  readonly " $fragmentType": "Notifications_viewer";
};
export type Notifications_viewer$key = {
  readonly " $data"?: Notifications_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Notifications_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchNotifications"
    },
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasSessionCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notifications_viewer",
  "selections": [
    {
      "condition": "hasSessionCountryCode",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "regInfo",
          "args": null,
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "isAutomatedOfferNotificationDisabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableAutomatedOfferBellNotification"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
    },
    {
      "condition": "fetchNotifications",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            },
            {
              "kind": "Literal",
              "name": "notifications",
              "value": true
            }
          ],
          "concreteType": "ConversationConnection",
          "kind": "LinkedField",
          "name": "conversations",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Conversations_conversations"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ActivityFeed_viewer"
            }
          ]
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "61590b4acbfd0f86eb217d303cb6a681";

export default node;
